import React from 'react';
import Navbar from '../components/layout/navbar/Navbar';
import ExperienceGreeting from '../components/layout/experience/ExperienceGreeting';
import Footer from '../components/layout/footer/Footer';

const Experience = () => {
  return (
    <div>
      <Navbar />
      <ExperienceGreeting />
      <Footer />
    </div>
  );
};

export default Experience;
